// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__38Csn","alertIcon":"ConfirmModal_alertIcon__2FFzB"};